/* ============================================================
   PLUSHIE PATCH — card buttons go to the product page
   Quick add from the cards was failing silently, so the card
   button is turned into a link to the product page, where adding
   to cart works. The story popup's button does the same.
   Remove this file (and its tag in layout/theme.liquid) to bring
   quick add back once the cause is fixed.
   ============================================================ */
(function () {
  "use strict";

  window.addEventListener('load', function () {
    /* 1. Swap each card's add button for a link to that product */
    document.querySelectorAll('.card button.add').forEach(function (btn) {
      if (btn.classList.contains('notify')) return;          // "Back soon" stays as is
      var card = btn.closest('.card');
      var link = card && card.querySelector('h3 a');
      if (!link || !link.getAttribute('href')) return;

      var a = document.createElement('a');
      a.className = btn.className;
      a.setAttribute('href', link.getAttribute('href'));
      a.textContent = 'View product';
      btn.parentNode.replaceChild(a, btn);
    });

    /* 2. The story popup's button: open the product page too */
    var products = window.PP_PRODUCTS || [];
    window.addToCart = function (variantId) {
      for (var i = 0; i < products.length; i++) {
        if (products[i] && String(products[i].id) === String(variantId) && products[i].url) {
          window.location.href = products[i].url;
          return;
        }
      }
    };
  });
})();
